import React from "react";
import styles from "./filter-dropdown.module.scss";
import Select from "react-select";

export default function FilterDropdown(props) {
    const { options, handleFilter, placeholder, filterState } = props;

    return (
        <div className={styles.filterDropdown}>
            <Select
                aria-label={`Options for ${placeholder}`}
                options={options}
                isMulti
                onChange={handleFilter}
                placeholder={placeholder}
                value={filterState}
                styles={{
                    multiValue: provided => ({
                        ...provided,
                        backgroundColor: "#D1ECF1",
                    }),
                    placeholder: provided => ({
                        ...provided,
                        color: "#707070",
                    }),
                }}
            />
        </div>
    );
}
